import { useRef, useState } from 'react';
import ReactNative from 'react-native';

interface UseOtpInputParams {
  maxLength?: number;
  onReady?: (ready: boolean) => void;
  onValueChange?: (value: string) => void;
}

export const useOtpInput = (params: UseOtpInputParams) => {
  const { maxLength = 6, onReady, onValueChange } = params;
  const [otp, setOtp] = useState(new Array(maxLength).fill(''));
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const inputRefs = useRef<Array<ReactNative.TextInput | null>>([]);

  const handleChange = (index: number, value: string) => {
    const newOtp = [...otp];
    const otpValues = value.split('');

    if (value.length >= maxLength) {
      let i = 0;
      while (true) {
        newOtp[i] = otpValues[i];
        i++;
        if (i === maxLength) break;
      }
    } else if (value.length > 1) {
      const values = otpValues.filter((x) => x !== newOtp[index]);
      if (values.length > 0) {
        newOtp[index] = values[values.length - 1];
      }
    } else {
      newOtp[index] = value;
    }

    setOtp(newOtp);
    if (value.length >= 1 && index < maxLength - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    if (newOtp.join('').trim().length === maxLength) {
      onReady && onReady(true);
      onValueChange && onValueChange(newOtp.join(''));
    }
  };

  const handleBackspace = (index: number) => {
    if (!otp[index]) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return {
    otp,
    inputRefs,
    focusedIndex,
    handleChange,
    handleBackspace,
    handleFocusedIndex: (index: number) => setFocusedIndex(index)
  };
};
